import axios from '../axios';

export interface LLMAnalysisResult {
  actionId: string | null;
  confidence: number;
  response: string;
  guideMode?: boolean;
  needsData?: boolean;
  data?: any;
  total?: number;
  noResultsMessage?: string;
  quotationType?: string;
  workVisibility?: string;
  isPublic?: boolean;
}

export interface ConversationMessage {
  role: 'user' | 'assistant';
  content: string;
  actionId?: string | null;
}

const getAuthHeaders = () => {
  const authToken = localStorage.getItem("access-Token-Edify");
  return { headers: { Authorization: `Bearer ${authToken}` } };
};

export const analyzeWithLLM = async (
  query: string, 
  history?: ConversationMessage[]
): Promise<LLMAnalysisResult> => {
  try {
    const response = await axios.post<{ 
      message: string; 
      data: { 
        validatedResponse?: LLMAnalysisResult;
        finalResponse?: LLMAnalysisResult;
      } 
    }>(
      '/chatbot/message',
      { 
        message: query,
        history: history || []
      },
      getAuthHeaders()
    );
    
    const responseData = response.data.data.validatedResponse || response.data.data.finalResponse;
    
    if (!responseData) {
      throw new Error('Respuesta del servidor en formato inesperado');
    }
    
    return responseData;
  } catch (error) {
    throw new Error('Error conectando con el servicio de análisis');
  }
};

